themeBase.requestIdleCallback(() => {
  themeSettings.disableStickyHeader = () => themeBase.isDesktop;
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded(['cart.js', 'product-form.js'], () => {
      if (!customElements.get('product-footbar')) {
        class ProductFootbar extends HTMLElement {
          constructor() {
            super();

            this.productSectionId = this.resolveProductSectionId();
            this.syncFootbarFormId();

            this.product = this.getProduct();
            this.productButtonAddToCart = this.getMainAddButton();
            this.productVisibilityAnchor = this.getMainVisibilityAnchor();
            this.variants = this.querySelector('.product-footbar__variants select[name="id"]') || this.querySelector('select[name="id"]');

            if (this.variants) {
              this.variants.addEventListener('change', this.onChange.bind(this));
            }
            window.addEventListener('MutationObserverLoaded', this.checkOverlay.bind(this));
            window.addEventListener('throttle30fpsMove', this.checkOverlay.bind(this));
          }

          resolveProductSectionId() {
            if (this.dataset.productSectionId) return this.dataset.productSectionId;

            const mainProductRoot = document.querySelector('.product.product--2026[data-main-product-section-id], .product[data-main-product-section-id]');
            const sectionId = mainProductRoot?.dataset?.mainProductSectionId;

            if (sectionId) {
              this.dataset.productSectionId = sectionId;
            }

            return sectionId || '';
          }

          syncFootbarFormId() {
            if (!this.productSectionId) return;

            const footbarForm = this.querySelector('form[data-type="add-to-cart-form"]');
            if (!footbarForm) return;

            footbarForm.id = `product-form-${this.productSectionId}-footbar`;
          }

          getProduct() {
            if (this.productSectionId) {
              return document.querySelector(`.product[data-main-product-section-id="${this.productSectionId}"]`) || document.querySelector('.product');
            }

            return document.querySelector('.product');
          }

          getMainAddButton() {
            if (!this.product) return null;

            return this.product.querySelector('.product__info-container [name="add"]') || this.product.querySelector('[name="add"]');
          }

          getMainVisibilityAnchor() {
            if (!this.product) return null;

            return this.product.querySelector('.product__info-container .product-form__buttons') ||
              this.product.querySelector('.product__info-container product-form') ||
              this.product.querySelector('.product__product-form') ||
              this.product.querySelector('product-form') ||
              this.product.querySelector('.product__info-container');
          }

          isForceVisible() {
            return this.dataset.forceVisible === 'true' ||
              this.classList.contains('product-footbar__wrapper--editor-selected') ||
              this.classList.contains('product-footbar__wrapper--visual-preview-mode');
          }

          setVisibleState(isVisible) {
            this.classList[isVisible ? 'add' : 'remove']('product-footbar__wrapper--visible');

            const visibleFootbar = document.querySelector('.product-footbar__wrapper.product-footbar__wrapper--visible:not(.product-footbar__wrapper--editor-selected)');
            const hasVisibleFootbar = !!visibleFootbar;

            document.body.classList[hasVisibleFootbar ? 'add' : 'remove']('product-footbar-visible');

            if (hasVisibleFootbar) {
              document.documentElement.style.setProperty('--product-footbar-height', `${themeBounds.get(visibleFootbar).height.toFixed(1) / 10}rem`);
            } else {
              document.documentElement.style.setProperty('--product-footbar-height', '');
            }
          }

          onChange(event) {
            if (!this.productSectionId) {
              this.productSectionId = this.resolveProductSectionId();
              this.syncFootbarFormId();
            }

            const options = event.target.querySelectorAll('option');
            const productVariantSwitcher = this.productSectionId ?
              (document.querySelector(`variant-radios[data-section="${this.productSectionId}"]`) || document.querySelector(`variant-selects[data-section="${this.productSectionId}"]`)) :
              (document.querySelector('variant-radios') || document.querySelector('variant-selects'));

            if (!productVariantSwitcher) return;

            options.forEach(element => {
              if (element.selected) {
                const variantDataHolder = productVariantSwitcher.querySelector('[type="application/json"]') || this.product?.querySelector('[type="application/json"]');
                if (!variantDataHolder) return;
                const variantData = JSON.parse(variantDataHolder.textContent);
                const currentVariant = variantData.variants.filter((variant) => {
                  return variant.id == element.value;
                })[0];
                if (!currentVariant) return;

                productVariantSwitcher.changeOptions(currentVariant.options);
                productVariantSwitcher.onVariantChange({
                  isFootbar: true
                });
                return false;
              }
            });
          }

          checkOverlay() {
            const forceVisible = this.isForceVisible();

            if (!this.productSectionId) {
              this.productSectionId = this.resolveProductSectionId();
              this.syncFootbarFormId();
            }

            if (!this.product || (!this.productButtonAddToCart && !this.productVisibilityAnchor)) {
              this.product = this.getProduct();
              this.productButtonAddToCart = this.getMainAddButton();
              this.productVisibilityAnchor = this.getMainVisibilityAnchor();
            }

            const visibilityAnchor = this.productButtonAddToCart || this.productVisibilityAnchor;

            if (!visibilityAnchor) {
              this.setVisibleState(forceVisible);
              return;
            }

            const visibilityAnchorBound = themeBounds.get(visibilityAnchor);
            const isVisible = forceVisible || visibilityAnchorBound.bottom < 0;

            this.setVisibleState(isVisible);
          }
        }

        customElements.define('product-footbar', ProductFootbar);
      }
    });
  });
});
